<template>
  <v-container>
    <div class="text-h6 pa-4 text-center">該当するものを選択してください</div>

    <v-row>
      <!-- 患者 -->
      <v-col cols="12">
        <v-card
          class="pa-3 cursor-pointer"
          outlined
          style="background-color: rgba(240, 169, 201, 0.3)"
          @click="createPatient"
        >
          <v-row justify="space-between">
            <v-col>
              <div class="text-h5 font-weight-bold">患者</div>
              <div class="text-body-1 text-grey-darken-1">
                体重、血圧、脈拍などの健康データを記録・管理できます。<br />
                心不全の兆候が見つかった際には通知が届き、医師や専門スタッフとチャットで相談できます。
              </div>
            </v-col>
            <v-icon>mdi-chevron-right</v-icon>
          </v-row>
        </v-card>
      </v-col>

      <!-- サポートメンバー -->
      <v-col cols="12">
        <v-card
          class="pa-3 cursor-pointer"
          outlined
          style="background-color: rgba(179, 225, 241, 0.3)"
          @click="createMember"
        >
          <v-row justify="space-between">
            <v-col>
              <div class="text-h5 font-weight-bold">サポートメンバー</div>
              <div class="text-body-1 text-grey-darken-1">
                患者様のご家族や医療・介護従事者の方は、こちらを選択してください。<br />
                患者様の健康データを閲覧でき、心不全の兆候が見つかった際には通知が届きます。
              </div>
            </v-col>
            <v-icon>mdi-chevron-right</v-icon>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- ログイン画面に戻る -->
    <v-btn class="mt-6" color="grey" outlined block @click="$router.push('/').catch(() => {})">
      ログイン画面に戻る
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "SelectUserType",
  data: () => ({}),
  methods: {
    createPatient() {
      // 患者登録
      this.$router.push("/patient").catch(() => {});
    },
    createMember() {
      // メンバー登録
      this.$router.push("/member").catch(() => {});
    },
    // キャンセル
    async cancel() {
      this.$router.push("/").catch(() => {});
    },
  },
};
</script>
